(function () {
  "use strict";

  yammerLoadingCtrl.$inject = ['$scope'];
  angular
    .module('trainerWebApp.controllers')
    .controller('yammerLoadingCtrl', yammerLoadingCtrl);

  function yammerLoadingCtrl($scope) {

  }

})();
